import { render, staticRenderFns } from "./RegistrationRequestSellerInfo.vue?vue&type=template&id=53cc7f24"
import script from "./RegistrationRequestSellerInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestSellerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports